// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "847dcf7a0e24e6bbe3df" + ".css";
};